/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_ConsentInputs */

const en_site_consent = /** @type {(inputs: Site_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I confirm this address is a public page and the dissection is for analysis and inspiration only. I will not imitate another site's brand, logo, text, images or distinctive look. Bystep does not bypass logins, captchas or paywalls.`)
};

const id_site_consent = /** @type {(inputs: Site_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya menyatakan alamat ini halaman publik; hasil bedah hanya untuk analisis dan inspirasi. Saya tidak akan meniru merek, logo, teks, gambar, atau tampilan khas situs lain. Bystep tidak menembus login, captcha, atau paywall.`)
};

/**
* | output |
* | --- |
* | "I confirm this address is a public page and the dissection is for analysis and inspiration only. I will not imitate another site's brand, logo, text, images ..." |
*
* @param {Site_ConsentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_consent = /** @type {((inputs?: Site_ConsentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_ConsentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_consent(inputs)
	return en_site_consent(inputs)
});